import { inject } from 'vue';

export function useShadowDom() {
  const $element = inject('$element', null);
  const standAlone = inject('standAlone', null);

  return (!standAlone && $element && $element.shadowRoot) || undefined;
}
